import { BaasHeroVisual } from './baas-hero-options';

export const _BAAS_HERO_VISUAL_BACKGROUND_MAPPINGS: Record<BaasHeroVisual, string> = {
    koeienLuchtfoto: 'text-bg-primary',
    koeienMelkenHandmatig: 'text-bg-accent',
    koeienWeiDrinken: 'text-bg-info',
    koeienWeideStal: 'text-bg-primary-100',
    lammerenWeiLente: 'text-bg-primary-100',
    landbouwerTractorVeld: 'text-bg-primary-100',
    serreManPlanten: 'text-bg-info-subtle',
    sierteeltBloemenPlanten: 'text-bg-error-200',
    suikerbietenOogstTractor: 'text-bg-vo-yellow',
    tractorWeiZaaien: 'text-bg-primary',
    varkenKopFrontaal: 'text-bg-error-subtle',
    veeKuddeWeideMist: 'text-bg-alert',
    weiZonsondergang: 'text-bg-primary-200-subtle'
} as const;
